import { Typography } from 'seagull';
import ExternalLinkButton from "../../../components/ExternalLinkButton";
import { routes } from "../../../constants";
import { useEventReporter, useOverlayContext, useStoreActions } from "../../../contexts";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import CopyAPIKeyModal from "../CopyAPIKeyModal/CopyAPIKeyModal";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import MondayLogo from "./MondayLogo";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function MondayCard() {
  const {
    api
  } = useStoreActions();
  const {
    reportToAppcues,
    reportToGtm,
    reportToHeap,
    reportToHubspot
  } = useEventReporter();
  const {
    MANAGE_API_KEYS
  } = useFeatureFlags();
  const overlayContext = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const openIntegrateModal = () => {
    logBI(12050);
    reportToAppcues('button-click', "monday-vendor-clicked-connect");
    reportToGtm('button-click', "monday-vendor-clicked-connect");
    reportToHeap('integrations', 'click', "monday-connect");
    reportToHubspot("vendor_clicked_connect_to_monday");
    const steps = MANAGE_API_KEYS ? [/*#__PURE__*/_jsxs(Typography, {
      children: ["1. Go to the", ' ', /*#__PURE__*/_jsx(ExternalLinkButton, {
        href: routes.anchorApiKeys,
        underline: "none",
        openInNewTab: true,
        children: "Anchor API Keys"
      }), ' ', "page and generate a new API key for Monday."]
    }), '2. Click Integrate on your monday.com board', '3. Search Anchor and select an automation recipe', '4. When prompted, paste your API key into the Anchor API Key field'] : ['1. Copy the API key below', '2. Click Integrate on your monday.com board', '3. Search Anchor and select an automation recipe', '4. When prompted, paste your API key into the Anchor API Key field'];
    overlayContext.showModal({
      closeOnEscapeKey: true,
      closeOnClickOutside: true,
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        return /*#__PURE__*/_jsx(CopyAPIKeyModal, {
          dismissModal: dismissModal,
          title: "monday.com",
          integrationUrl: "https://monday.com/",
          testId: "monday",
          steps: steps,
          getApiKey: () => api.monday.getApiKey(),
          onCopyApiKey: () => {
            logBI(12051);
            reportToAppcues('button-click', "monday-vendor-copied-api-key-to-clipboard");
            reportToGtm('button-click', "monday-vendor-copied-api-key-to-clipboard");
            reportToHeap('integrations', 'click', "monday-copy-api-key");
            reportToHubspot('vendor_copied_api_key_to_clipboard');
          }
        });
      }
    });
  };
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "monday-card",
    icon: /*#__PURE__*/_jsx(MondayLogo, {}),
    title: "monday.com",
    subTitle: "Automate proposals and billing directly from your monday boards",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: openIntegrateModal,
      "data-testid": "monday-card-connect",
      children: "Connect"
    })
  });
}